@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../respond-to.scss';

.ci-drawer {
  // js, apply to body tag
  &-disable-scroll {
    overflow: hidden;
  }
  &-overlayClickable {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    z-index: 5;
  }
  &-overlay {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.28);
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    z-index: -1;
  }

  .openOverlay {
    animation: forwards fadeIn 0.2s;
  }

  .closeOverlay {
    animation: forwards fadeOut 0.3s;
  }

  &-menu {
    position: absolute;
    left: -336px;
    top: 0;
    width: 336px;
    background-color: $color-shade-white;
    z-index: 30;
    box-sizing: content-box;
    height: calc(100vh - 86px);
    overflow: auto;
  }

  .openMenu {
    animation: ease-in forwards slideIn 0.2s;
  }

  .closeMenu {
    animation: ease-out forwards slideOut 0.2s;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  @keyframes slideIn {
    0% {
      left: -336px;
    }
    100% {
      left: 0;
    }
  }

  @keyframes slideOut {
    0% {
      left: 0;
    }
    100% {
      left: -336px;
    }
  }

  &-window {
    position: absolute;
    top: 87px;
    left: 0;
    height: 100%;
    width: 100%;
    min-height: 100vh;
    background-color: transparent;
    padding: 10px;
    box-sizing: border-box;
  }
}

@include breakpoint('lg') {
  .ci-drawer {
    &-overlay {
      position: absolute;
      z-index: 5;
    }
  }
}
@include breakpoint('xl') {
  .ci-drawer {
    &-overlay {
      position: absolute;
      z-index: 5;
    }
  }
}
